export default "__VITE_ASSET__Qc1AqFlm__"